import { mb, mt, p } from '@upgrade/react-components/Spacing/core';
import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const StyledIframe = styled.iframe`
  width: 100%;
  height: max(200px, 50vw);
  @media (min-width: ${props => props.theme.mediaSm}) {
    width: ${({ $width }) => $width ?? '560px'};
    height: ${({ $height }) => $height ?? '315px'};
  }
`;

export const Container = styled.div`
  ${p('md')};

  p {
    ${mb('xl')};
  }

  & > div {
    ${mt('xl')};
  }
`;

export const VimeoVideoContainer = styled.div`
  padding: 56.25% 0 0 0;
  margin: 0 auto;
  position: relative;
  border-radius: 24px;
  overflow: hidden;
`;
